import { getSelectors } from '@repo/core'
import { MASTER_TABLE_KEYS, type MasterTableItem, type MasterTableKey } from '@repo/shared-types'
import { RootState } from '../../store/types'

export const masterTableSelectors = MASTER_TABLE_KEYS.reduce(
  (acc, key) => ({
    ...acc,
    [key]: getSelectors<MasterTableItem[], RootState>({
      getRootPath: (state) => state.catalogs.masterTables[key],
    }),
  }),
  {} as Record<MasterTableKey, ReturnType<typeof getSelectors<MasterTableItem[], RootState>>>,
)
